@if (tour.activeTour() && tour.currentStep(); as step) {
  @if (cutoutStyle(); as cs) {
    <div class="tour-cutout" [style.top]="cs.top" [style.left]="cs.left" [style.width]="cs.width" [style.height]="cs.height" aria-hidden="true"></div>
  }

  <div
    #popoverRef
    class="tour-popover"
    [class]="'placement-' + popoverPos().placement"
    [style.top.px]="popoverPos().top"
    [style.left.px]="popoverPos().left"
    role="dialog"
    [attr.aria-label]="step.titleKey | translate"
  >
    <div class="tour-popover-arrow" aria-hidden="true"></div>

    <header class="tour-popover-header">
      <span class="tour-popover-step">{{ tour.stepIndex() + 1 }} / {{ tour.totalSteps() }}</span>
      <button type="button" class="tour-popover-close" (click)="onSkip()" [attr.aria-label]="'tour.skip' | translate">
        <fa-duotone-icon [icon]="faXmark"></fa-duotone-icon>
      </button>
    </header>

    <h3 class="tour-popover-title">{{ step.titleKey | translate }}</h3>
    <p class="tour-popover-body">{{ step.bodyKey | translate }}</p>

    <div class="tour-popover-progress" aria-hidden="true">
      @for (i of [].constructor(tour.totalSteps()); track $index) {
        <span class="tour-popover-pip" [class.active]="$index <= tour.stepIndex()"></span>
      }
    </div>

    <div class="tour-popover-kbd" aria-hidden="true">{{ 'tour.kbdHint' | translate }}</div>

    <footer class="tour-popover-footer">
      <button type="button" class="tour-popover-skip" (click)="onSkip()">{{ 'tour.skip' | translate }}</button>
      <div class="tour-popover-nav">
        @if (!tour.isFirst()) {
          <button type="button" class="tour-popover-btn ghost" (click)="onPrev()">
            <fa-duotone-icon [icon]="faArrowLeft"></fa-duotone-icon>
            <span>{{ 'tour.prev' | translate }}</span>
          </button>
        }
        <button type="button" class="tour-popover-btn primary" (click)="onNext()">
          @if (tour.isLast()) {
            <span>{{ 'tour.done' | translate }}</span>
            <fa-duotone-icon [icon]="faCheck"></fa-duotone-icon>
          } @else {
            <span>{{ 'tour.next' | translate }}</span>
            <fa-duotone-icon [icon]="faArrowRight"></fa-duotone-icon>
          }
        </button>
      </div>
    </footer>
  </div>
}
